import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  Box,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { DialogCreateReminder } from "components/Dialogs/DialogCreateReminderConsumidor360";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";

const useStyles = makeStyles(componentStyles);

export default function Reminders({
  isMobile500,
  reminders,
  cpf,
  idLoja,
  idVendedor,
  customerDetail,
  setHasUpdatedReminders,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
      }}
    >
      <Grid item xs={12}>
        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <Grid
            item
            xs={12}
            style={{
              marginTop: "0.75rem",
              display: "flex",
              flexDirection: isMobile500 ? "column" : "row",
              justifyContent: "space-between",
              alignItems: isMobile500 ? "flex-start" : "center",
            }}
          >
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Lembretes</Box>
            </Box>
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Button
                style={{ marginTop: isMobile500 ? "0.75rem" : 0 }}
                variant="contained"
                onClick={() => setOpenDialog(true)}
              >
                Adicionar Lembrete
              </Button>
            </Box>
          </Grid>
          <Divider style={{ margin: "0.85rem 0" }} />
          <Grid item xs={12}>
            {reminders?.map((item) => (
              <Accordion
                key={item?.Id}
                expanded={expanded === item?.Id}
                onChange={handleChange(item?.Id)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div
                    role="presentation"
                    style={{
                      display: "flex",
                      flexDirection: isMobile500 ? "column" : "row",
                    }}
                  >
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Título: </span>{" "}
                      {item?.Motivo}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Divider style={{ marginBottom: "0.75rem" }} />
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Data Inicial: </span>{" "}
                      {item?.DataInicialFormat}
                    </Typography>
                    <Typography variant="body2" style={{ margin: "0.5rem 0" }}>
                      <span style={{ fontWeight: "600" }}>Data Final: </span>{" "}
                      {item?.DataFinallFormat}
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Motivo: </span>{" "}
                      {item?.Motivo}
                    </Typography>
                    <Typography variant="body2" style={{ margin: "0.5rem 0" }}>
                      <span style={{ fontWeight: "600" }}>Dica: </span>{" "}
                      {item?.Dica}
                    </Typography>
                  </Grid>
                  <Divider style={{ margin: "0.7rem 0" }} />
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Card>
      </Grid>
      {openDialog && (
        <DialogCreateReminder
          setHasUpdatedReminders={setHasUpdatedReminders}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          cpf={cpf}
          idLoja={idLoja}
          idVendedor={idVendedor}
          customerDetail={customerDetail}
        />
      )}
    </Grid>
  );
}
